/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Valid status types for allergies.
 */
export type StatusTypeT = (typeof StatusTypeT)[keyof typeof StatusTypeT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusTypeT = {
  Active: "Active",
  Inactive: "Inactive",
  Deleted: "Deleted",
} as const;
